import React from 'react';
import "./home.css";
import Social from './Social';
import Data from './Data';
import ScrollDown from './ScrollDown';
import AuthPromptBox from './AuthPromptBox';
import OverviewPanel from '../dashboard/OverviewPanel';
import heroPortrait from '../../assets/profile.jpg';

const Home = ({ isAuthenticated }) => {
  // Signed-in clients land on their dashboard Overview right here on the home page.
  if (isAuthenticated) {
    return (
      <section className="home section" id="home">
        <div
          className="home__container container"
          style={{ paddingTop: '5.5rem', paddingBottom: '3rem' }}
        >
          <OverviewPanel />
        </div>
      </section>
    );
  }

  // Guests see the marketing hero.
  return (
    <section className="home section" id="home">
      <div className="home__container container grid">
        <div className="home__content grid">
          <Social />
          {/* Wrapper keeps the morphing-blob shape, rotating ring, and glow.
              The <img> inside is what Google Images can actually index. */}
         <div className="home__img">
  <img
    src={heroPortrait}
    alt="Spinoza Delva — illustrated portrait"
    className="home__photo"
    width="320"
    height="320"
  />
          </div>
          <Data />
        </div>

        {/* Auth Prompt Box - Only show if not authenticated */}
        <AuthPromptBox />

        <ScrollDown/>
      </div>
    </section>
  )
}

export default Home;